export { default } from "./TeacherComponent";
